<template>
  <div class="fl-sym-mt-10 fl-sym-p-2" @click="$refs['weight'].focus()">
    <div class="fl-sym-text-xxs fl-sym-text-dark-blue fl-sym-letter-space-08">CREATE PET PROFILE</div>
    <div class="fl-sym-text-5xl fl-sym-font-bold fl-sym-letter-space-minus-02">Let's add a photo</div>
    <div class="fl-sym-text-secondary fl-sym-text-lg fl-sym-mt-2 fl-sym-letter-space-056">
      Say cheese! It's time to put a face to the name.
    </div>
    <div class="fl-sym-flex fl-sym-justify-between fl-sym-mt-5">
      <div
          class="fl-sym-w-1/5 height-5 fl-sym-bg-dark-blue radius-25"
      ></div>
      <div
          class="fl-sym-w-1/5 height-5 fl-sym-bg-dark-blue radius-25"
      ></div>
      <div
          class="fl-sym-w-1/5 height-5 fl-sym-bg-dark-blue radius-25"
      ></div>
      <div
          class="fl-sym-w-1/5 height-5 fl-sym-bg-dark-blue radius-25"
      ></div>
    </div>
    <form class="fl-sym-mt-10" @submit="next">
      <div class="add-photo">
        <div class="fl-sym-text-dark-blue">
          <font-awesome-icon icon="camera"></font-awesome-icon>
          <p class="fl-sym-mt-2">Take photo</p>
        </div>
      </div>
      <div class="fl-sym-text-center fl-sym-mt-5">
        <p class="or"> OR</p>
        <p class="fl-sym-mt-4 fl-sym-text-dark-blue fl-sym-font-semibold"> Choose from your library</p>
      </div>
      <button
          class="button-blue-gradient hover:fl-sym-text-opacity-75 fl-sym-mt-10 fl-sym-rounded-full fl-sym-text-white fl-sym-p-4 fl-sym-w-full fl-sym-text-sm symptom-btn"
          type="submit">Complete profile

      </button>
    </form>
    <div class="fl-sym-text-center fl-sym-mt-3">
      <span
          class="fl-sym-mx-auto fl-sym-font-semibold fl-sym-text-dark-blue fl-sym-text-sm opacity-75 fl-sym-cursor-pointer"
          @click="$router.go(-1)"
      >
        Back
      </span>
    </div>
  </div>
</template>
<style>

.add-photo {
  width: 40vmin;
  height: 40vmin;
  margin: auto;
  border: solid 1px #B8C1C1;
  border-radius: 50%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media only screen and (max-width: 420px) {
  .add-photo {
    width: 50vmin;
    height: 50vmin;
  }
}

.add-photo svg {
  font-size: 15vmin;
}

.add-photo p {
  font-size: 5vmin;
}

.or {
  color: #B8C1C1;
}
</style>
<script>
import {mapState} from "vuex";
import Weight from "@/pages/pet/create/Weight";

export default {
  components: {
    Weight
  },
  computed: {
    ...mapState({
      pet: (state) => state.pet.pet,
    }),
  },
  data() {
    return {
      options: [
        {
          name: "Male",
        },
        {
          name: "Female",
        },
      ],
    };
  },
  methods: {
    next() {
      this.$router.push({name: process.env.VUE_APP_PET_CREATE_PROFILE});
    },
  },
};
</script>
